import { render, staticRenderFns } from "./DelManagerExternalOverview.vue?vue&type=template&id=0819a650&"
import script from "./DelManagerExternalOverview.vue?vue&type=script&lang=js&"
export * from "./DelManagerExternalOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports